import { render, staticRenderFns } from "./ProductOrderPrint.vue?vue&type=template&id=56950e7a&scoped=true&"
import script from "./ProductOrderPrint.vue?vue&type=script&lang=js&"
export * from "./ProductOrderPrint.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderPrint.vue?vue&type=style&index=0&id=56950e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56950e7a",
  null
  
)

export default component.exports